var GPC_ZEROES_ANALYTICS = true;

function gpcActive() {
  return navigator.globalPrivacyControl === true;
}

function cookiebotReady() {
  return typeof window.Cookiebot !== 'undefined' &&
         typeof window.Cookiebot.submitCustomConsent === 'function';
}

function shopifyPrivacyReady() {
  return !!(window.Shopify &&
            window.Shopify.customerPrivacy &&
            typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function');
}

function loadShopifyPrivacy(cb) {
  if (shopifyPrivacyReady()) { cb(); return; }
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) { console.error('Shopify consent API failed to load', error); return; }
        cb();
      }
    );
    return;
  }
  /* Shopify global not present yet — retry briefly. */
  var tries = 0;
  var poll = setInterval(function () {
    if (++tries > 20) { clearInterval(poll); return; }
    if (window.Shopify) {
      clearInterval(poll);
      loadShopifyPrivacy(cb);
    }
  }, 250);
}

/* Builds the full payload from Cookiebot state, with GPC applied.
 * Re-evaluates GPC on every call so it cannot be overwritten by cb-embed. */
function buildConsentPayload() {
  var C = (window.Cookiebot && window.Cookiebot.consent) || {};
  var gpc = gpcActive();
  var marketing = gpc ? false : !!C.marketing;

  return {
    analytics:    (gpc && GPC_ZEROES_ANALYTICS) ? false : !!C.statistics,
    marketing:    marketing,
    preferences:  !!C.preferences,
    sale_of_data: marketing
  };
}

var OPT_OUT_PAYLOAD = {
  analytics: false,
  marketing: false,
  preferences: true,
  sale_of_data: false
};

/* Low-level write. Only reconcile() should call this. */
function applyConsent(payload, done) {
  loadShopifyPrivacy(function () {
    window.Shopify.customerPrivacy.setTrackingConsent(payload, function (result) {
      if (result && result.error) {
        console.error('setTrackingConsent failed', result.error);
      }
      if (typeof done === 'function') done();
    });
  });
}

/* ---- Serialized reconciler ------------------------------------------------
 * The single entry point for writing consent to Shopify.
 *
 * - Compares the desired payload against Shopify's *stored* state
 *   (currentVisitorConsent), not a local cache, so writes by cb-embed.js
 *   cannot make it stale.
 * - Never runs two setTrackingConsent requests concurrently. Concurrent
 *   requests without a _shopify_s cookie each receive a different session
 *   ID, which is what causes session rotation.
 * - Calls that arrive while a write is in flight are coalesced into one
 *   follow-up run.
 * - Caps corrective writes per page load so a value Shopify will not
 *   store (e.g. sale_of_data in a non-opt-out region) cannot loop with
 *   the visitorConsentCollected listener.
 * ------------------------------------------------------------------------ */
var reconcileBusy = false;
var reconcileAgain = false;
var reconcileWrites = 0;
var reconcileOverride = null;
var reconcileWaiters = [];
var MAX_CORRECTIVE_WRITES = 3;

function yn(b) { return b ? 'yes' : 'no'; }

function shopifyMatches(want) {
  var cur = window.Shopify.customerPrivacy.currentVisitorConsent() || {};
  return cur.analytics    === yn(want.analytics) &&
         cur.marketing    === yn(want.marketing) &&
         cur.preferences  === yn(want.preferences) &&
         cur.sale_of_data === yn(want.sale_of_data);
}

function reconcile(done, override) {
  if (typeof done === 'function') reconcileWaiters.push(done);
  if (override) reconcileOverride = override;
  if (reconcileBusy) { reconcileAgain = true; return; }
  reconcileBusy = true;

  function finish() {
    reconcileBusy = false;
    if (reconcileAgain) { reconcileAgain = false; reconcile(); return; }
    var waiters = reconcileWaiters;
    reconcileWaiters = [];
    waiters.forEach(function (fn) { fn(); });
  }

  loadShopifyPrivacy(function () {
    var want = reconcileOverride || buildConsentPayload();
    reconcileOverride = null;
    if (shopifyMatches(want)) { finish(); return; }
    if (reconcileWrites >= MAX_CORRECTIVE_WRITES) {
      console.warn('Consent reconcile cap reached; stored state still differs', want);
      finish();
      return;
    }
    reconcileWrites++;
    applyConsent(want, finish);
  });
}

/* Writes opt-out to both Cookiebot and Shopify's Customer Privacy API.
 * Always invokes `done`, even if a downstream call never returns. */
function applyOptOut(done) {
  var finished = false;
  function finish() {
    if (finished) return;
    finished = true;
    clearTimeout(guard);
    if (typeof done === 'function') done();
  }
  var guard = setTimeout(finish, 4000);

  if (cookiebotReady()) {
    try {
      /* (preferences, statistics, marketing) — functional cookies retained. */
      window.Cookiebot.submitCustomConsent(true, false, false);
    } catch (e) {
      console.error('submitCustomConsent failed', e);
    }
  }

  /* Routed through the reconciler so it never runs concurrently with
   * any other write. */
  reconcile(finish, OPT_OUT_PAYLOAD);
}

(function () {

  /* Primary trigger: runs after any consent write has landed (cb-embed's
   * or ours). The first write has already set _shopify_s, so any
   * corrective write reuses it instead of minting a new session. */
  document.addEventListener('visitorConsentCollected', function () { reconcile(); });

  /* Fallback for when cb-embed.js is absent or fails. Delayed so that
   * when cb-embed is present, its write has normally landed and
   * reconcile() is a no-op. */
  ['CookiebotOnAccept', 'CookiebotOnDecline', 'CookiebotOnConsentReady']
    .forEach(function (evt) {
      window.addEventListener(evt, function () {
        setTimeout(function () { reconcile(); }, 1500);
      });
    });

  function whenCookiebotReady(cb) {
    if (cookiebotReady()) { cb(); return; }
    window.addEventListener('CookiebotOnLoad', function handler() {
      if (cookiebotReady()) {
        window.removeEventListener('CookiebotOnLoad', handler);
        cb();
      }
    });
  }

  function init() {
    /* Guard against a stale static dialog left in theme markup. */
    var existing = document.getElementById('cookiePopup');
    if (existing) { existing.remove(); }

    var popup = document.createElement('dialog');
    popup.id = 'cookiePopup';

    var closeX = document.createElement('button');
    closeX.type = 'button';
    closeX.className = 'close-x';
    closeX.setAttribute('aria-label', 'Close');
    closeX.innerHTML = '&times;';

    var heading = document.createElement('h2');
    heading.textContent = 'Cookies Preferences';

    var actions = document.createElement('div');
    actions.className = 'popup-actions';

    var dnsBtn = document.createElement('button');
    dnsBtn.type = 'button';
    dnsBtn.className = 'popup-button';
    dnsBtn.id = 'hh-dns';
    dnsBtn.textContent = 'Do Not Sell or Share My Personal Information';

    var prefsBtn = document.createElement('button');
    prefsBtn.type = 'button';
    prefsBtn.className = 'popup-button';
    prefsBtn.id = 'hh-prefs';
    prefsBtn.textContent = 'Manage Preferences';

    actions.appendChild(dnsBtn);
    actions.appendChild(prefsBtn);

    popup.appendChild(closeX);
    popup.appendChild(heading);
    popup.appendChild(actions);
    document.body.appendChild(popup);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fixed-contact-cta-button cookie-cta';
    btn.setAttribute('aria-label', 'Cookies Preferences');
    btn.innerHTML =
      '<svg class="cookie-icon" viewBox="0 0 24 24" width="22" height="22" ' +
      'fill="currentColor" aria-hidden="true" focusable="false">' +
      '<path d="M21.6 11.2a4 4 0 0 1-4.6-4.8 4 4 0 0 1-3.7-3.9A9.5 9.5 0 1 0 21.6 11.2z"/>' +
      '<circle cx="9" cy="9" r="1.3" fill="#c31d2e"/>' +
      '<circle cx="8" cy="15" r="1.1" fill="#c31d2e"/>' +
      '<circle cx="13.5" cy="16" r="1.3" fill="#c31d2e"/>' +
      '<circle cx="14" cy="11.5" r="1" fill="#c31d2e"/>' +
      '</svg>' +
      '<span class="cta-label">Cookies Preferences</span>';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      //popup.showModal();
      window.Cookiebot.show();
    });
    document.body.appendChild(btn);

    closeX.addEventListener('click', function (e) {
      e.preventDefault();
      popup.close();
    });

    /* Backdrop click closes. */
    popup.addEventListener('click', function (e) {
      if (e.target === popup) { popup.close(); }
    });

    dnsBtn.addEventListener('click', function (e) {
      e.preventDefault();
      dnsBtn.disabled = true;
      applyOptOut(function () {
        dnsBtn.disabled = false;
        popup.close();
        alert('Your opt-out request has been processed successfully.');
      });
    });

    prefsBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (cookiebotReady() && typeof window.Cookiebot.show === 'function') {
        popup.close();
        window.Cookiebot.show();
      } else {
        alert('The consent manager is still loading. Please try again in a moment.');
      }
    });

    /* GPC: opt out in Cookiebot only if its state still allows tracking.
     * Avoids re-submitting consent (and re-logging it in Cookiebot) on every
     * page load. The Shopify side is re-asserted via buildConsentPayload(). */
    if (gpcActive()) {
      whenCookiebotReady(function () {
        var C = window.Cookiebot.consent || {};
        if (C.marketing || C.statistics) { applyOptOut(); }
        else { reconcile(); }
      });
    }

    /* Visitors with no Cookiebot response yet: register "no" with Shopify
     * until they choose. buildConsentPayload() yields all-false here, and
     * reconcile() skips the write if Shopify already has it. Replaces the
     * unconditional deny write from the old theme.liquid snippet. */
    whenCookiebotReady(function () {
      if (!window.Cookiebot.hasResponse) { reconcile(); }
    });
  }

  /* Returning visitors: uc.js is synchronous and may have fired
   * CookiebotOnConsentReady before this deferred script registered listeners.
   * No-op if Shopify's stored state already matches. */
  if (window.Cookiebot &&
      (window.Cookiebot.consented === true || window.Cookiebot.declined === true)) {
    setTimeout(function () { reconcile(); }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();